export const packageList = [
  {
    name: 'bigdata',
    activeRule: ['kyact'],
  },
  {
    name: 'kyetree',
    activeRule: ['kyetree-bdp'],
  },
  {
    name: 'kyetree_basic',
    activeRule: ['kyetree']
  },
  {
    name: 'kyetree_cost',
    activeRule: ['kyetree-cost']
  },
  {
    name: 'kyetree_cust',
    activeRule: ['kyetree-cust']
  },
  {
    name: 'kyetree_emp',
    activeRule: ['kyetree-emp']
  },
  {
    name: 'kyetree_sales',
    activeRule: ['kyetree-sales']
  },
  {
    name: 'kyetree_platform',
    activeRule: ['kyetree-platform']
  }
]

export const remoteModuleConfig = {
  dev: ['bigdata', 'kyetree', 'kyetree_basic', 'kyetree_cost', 'kyetree_cust', 'kyetree_emp', 'kyetree_sales', 'kyetree_platform'],
  stg: ['bigdata', 'kyetree', 'kyetree_basic', 'kyetree_cost', 'kyetree_cust', 'kyetree_emp', 'kyetree_sales', 'kyetree_platform'],
  uat: ['bigdata', 'kyetree', 'kyetree_basic', 'kyetree_cost', 'kyetree_cust', 'kyetree_emp', 'kyetree_sales', 'kyetree_platform'],
  prd: ['bigdata', 'kyetree', 'kyetree_basic', 'kyetree_cost', 'kyetree_cust', 'kyetree_emp', 'kyetree_sales', 'kyetree_platform'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/bigdata/index.js